import React from "react";

const WtbInitial = (props) => {
    let url = window.location;
    let image = (
        <img
            srcSet="https://embed.widencdn.net/img/vollrath/j8hhfhfgqr/x220px@2x/PRO_Photo_Missing_glm_11_22.jpeg?q=80"
            loading="lazy"
        />
    );

    const local = !props.state.hideLocal
        ? <div style={{ padding: "20px" }} className="col-lg-6 col-xs-12 wtb-btn-col">
            <a className="wtb-wrapper" href={`${props.state.localUrl}`} tabIndex="-1">
                <div className="wtb-card">
                    <div className="wtb-image">
                        <img
                            srcSet="/img/north-america.png"
                            loading="lazy"
                            alt="North america"
                        />
                    </div>
                    <div className="wtb-info">
                        <div>
                            <span> Dealers </span>
                            <p className="dealer-desc"> {props.state.localText} </p>
                        </div>
                    </div>
                </div>
            </a>
        </div>
        : <React.Fragment></React.Fragment>;

    const intl = !props.state.hideIntl
        ? <div style={{ padding: "20px" }} className="col-lg-6 col-xs-12 wtb-btn-col">
            <a className="wtb-wrapper" href={`${props.state.internationalUrl}`} tabIndex="-1">
                <div className="wtb-card">
                    <div className="wtb-image">
                        <img
                             srcSet="/img/globe.png"
                             loading="lazy"
                             alt="Building with a truck"
                        />
                    </div>
                    <div className="wtb-info">
                        <div>
                            <span> International Dealers </span>
                            <p className="dealer-desc"> {props.state.internationalText} </p>
                        </div>
                    </div>
                </div>
            </a>
        </div>
        : <React.Fragment></React.Fragment>;

    const servingSystemSales = !props.state.hideServingSystemSales
        ? <div style={{ padding: "20px" }} className="col-lg-6 col-xs-12 wtb-btn-col">
            <a className="wtb-wrapper" href={`${props.state.servingSystemSalesUrl}`} tabIndex="-1">
                <div className="wtb-card">
                    <div className="wtb-image">
                        <img
                            srcSet="/img/icon_serv_sys.svg"
                            loading="lazy"
                            alt="Building with a truck"
                        />
                    </div>
                    <div className="wtb-info">
                        <div>
                            <span> Serving System Sales  </span>
                            <p className="dealer-desc"> {props.state.servingSystemSalesText} </p>
                        </div>
                    </div>
                </div>
            </a>
        </div>
        : <React.Fragment></React.Fragment>;

    const productSales = !props.state.hideProductSales
        ? <div style={{ padding: "20px" }} className="col-lg-6 col-xs-12 wtb-btn-col">
            <a className="wtb-wrapper" href={`${props.state.productSalesUrl}`}>
                <div className="wtb-card">
                    <div className="wtb-image">
                        <img
                            srcSet="/img/icon_sales_team.svg"
                            loading="lazy"
                            alt="Building with a truck"
                        />
                    </div>
                    <div className="wtb-info">
                        <div>
                            <span> Product Sales </span>
                            <p className="dealer-desc"> {props.state.productSalesText} </p>
                        </div>
                    </div>
                </div>
            </a>
        </div>
        : <React.Fragment></React.Fragment>;

    return (
        <div className="row justify-content-center section equal-margin">
            {local}
            {intl}
            {servingSystemSales}
            {productSales}
        </div>
    );
};

export default WtbInitial;